// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../graphql/api/index';

import { gql } from 'graphql-tag';
import { MoneyFragmentDoc } from '../../graphql/api/fragments/money.fragment.generated';
export const TaxSnippetFragmentDoc = gql`
    fragment taxSnippet on SalePrice {
  __typename
  total {
    ...money
  }
  tax {
    type
  }
}
    ${MoneyFragmentDoc}`;